"use client";

import { useEffect, useState } from "react";

export default function HeroBannerVideo() {
  const [mounted, setMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showPoster, setShowPoster] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const mobile = window.innerWidth < 768;
    setIsMobile(mobile);

    let posterTimer;
    let videoTimer;
    let cleanupPreload = null;
    let cancelled = false;
    let preloader = null;
    let onCanPlay = null;

    // Skeleton → Poster
    posterTimer = setTimeout(() => {
      setShowPoster(true);
    }, 40);

    // Poster → Video
    const videoSrc = mobile ? "/home-mobile-hero.mp4" : "/home-desktop-hero.mp4";

    // Warm the video cache ASAP without affecting layout/CSS.
    try {
      const head = document?.head;
      const link = document?.createElement?.("link");
      preloader = document?.createElement?.("video");

      if (head && link) {
        link.rel = "preload";
        link.as = "video";
        link.href = videoSrc;
        link.type = "video/mp4";
        head.appendChild(link);

        cleanupPreload = () => {
          try {
            head.removeChild(link);
          } catch {}
        };
      }

      if (preloader) {
        preloader.muted = true;
        preloader.playsInline = true;
        preloader.preload = "auto";
        preloader.src = videoSrc;
        preloader.load();

        onCanPlay = () => {
          if (cancelled) return;
          setPlayVideo(true);
          if (videoTimer) clearTimeout(videoTimer);
        };

        preloader.addEventListener("canplay", onCanPlay, { once: true });
        preloader.addEventListener("canplaythrough", onCanPlay, { once: true });
      }
    } catch {
      // best-effort only
    }

    // Fallback: preserve existing behavior if preload doesn't signal readiness.
    videoTimer = setTimeout(() => {
      setPlayVideo(true);
    }, 2500);

    return () => {
      cancelled = true;
      if (posterTimer) clearTimeout(posterTimer);
      if (videoTimer) clearTimeout(videoTimer);
      if (cleanupPreload) cleanupPreload();
      if (preloader && onCanPlay) {
        try {
          preloader.removeEventListener("canplay", onCanPlay);
          preloader.removeEventListener("canplaythrough", onCanPlay);
          preloader.src = "";
          preloader.load();
        } catch {}
      }
    };
  }, [mounted]);

  if (!mounted) {
    return (
      <div className="relative w-full h-[102vh] overflow-hidden rounded-0 mtspace5" />
    );
  }

  return (
    <>
    {/* 🟡 Skeleton */}
      {!showPoster && (
        <div className="absolute inset-0" />
      )}
    <div className="relative w-full h-[102vh] overflow-hidden rounded-0">
      {playVideo && (
        <video
          className={`absolute w-full h-full object-cover ${
            isMobile ? "for-mobile-video-main" : "for-desktop-video-main"
          }`}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source
            src={
              isMobile
                ? "/home-mobile-hero.mp4"
                : "/home-desktop-hero.mp4"
            }
            type="video/mp4"
          />
        </video>
      )}
    </div>
    </>
  );
}
